import z from 'zod'
import {
  nullSafeBoolean,
  nullSafeOptionalBoolean,
  nullSafeOptionalFirestoreTimestamp,
  nullSafeOptionalNumber,
  nullSafeOptionalString,
  nullSafeOptionalStringArray,
  nullSafeString,
} from '../shared/schema'
import { UserProfileRole } from './types'

// this is the dart definition
// final String? emailAddress;
// final String? hubspotContactId;
// final int? hubspotDealId;
// final AppRole role;
// final bool userActive true;
// final bool onboardComplete false
export const schema = z.object({
  emailAddress: nullSafeString(''),
  // deprecated, but still set in older canvas users
  canvasUserId: nullSafeOptionalString(),
  // new field
  ltiUserId: nullSafeOptionalString(),
  ltiSource: nullSafeOptionalString(),
  ltiDomain: nullSafeOptionalString(),
  hubspotContactId: nullSafeOptionalString(),
  hubspotDealId: nullSafeOptionalNumber(),
  // initial value is set from hubspot, then can be updated by the user
  company: nullSafeOptionalString(),
  role: z.preprocess(
    (val) => (val as UserProfileRole) ?? UserProfileRole.student,
    z.nativeEnum(UserProfileRole)
  ),
  onboardComplete: nullSafeBoolean(false),
  walkthroughComplete: nullSafeBoolean(false),
  updatedAt: nullSafeOptionalFirestoreTimestamp(),
  userActive: nullSafeOptionalBoolean(true),
  hasPromotions: nullSafeOptionalBoolean(false),
  anonymous: nullSafeOptionalBoolean(false),
  language: nullSafeOptionalString(),
  timezone: nullSafeOptionalString(),
  stripeCustomerId: nullSafeOptionalString(),
  transcriptionLanguage: nullSafeOptionalStringArray(),
  requiresInvitation: nullSafeOptionalBoolean(false),
  hideDefaultProducts: nullSafeOptionalBoolean(false),
  externalCanDemo: nullSafeOptionalBoolean(false),
  isTest: nullSafeOptionalBoolean(false),
})

export const empty = Object.freeze(
  schema.parse({
    emailAddress: '',
    role: UserProfileRole.student,
    onboardComplete: false,
  })
)

export interface FirestoreUserProfile extends z.infer<typeof schema> {}
